<data-list>
  @if (type) {
  <app-card web-content>
    <img src="{{ type.PictureUri }}" />

    <title-with-divider>
      <h1>{{type.Alias}}</h1>
    </title-with-divider>
    @if(type.Attributes)
    {
    <div class="row">
      <ng-container *ngFor="let item of dimensions">
        @if(item.Value){
        <div class="col-8">
          {{ item.Name | translate }}
        </div>
        <div class="col-4">
          {{ item.Value }}{{ item.Unit | translate}}
        </div>
        }
      </ng-container>

      <ng-container *ngFor="let item of weights">
        @if(item.Value){
        <div class="col-8">
          {{ item.Name | translate }}
        </div>
        <div class="col-4">
          {{ item.Value }}{{ item.Unit | translate}}
        </div>
        }
      </ng-container>
    </div>
    }

    @if (showPrice) {
    <title-with-divider>
      @if (loadingPrice) {
      <mat-progress-spinner diameter="25" mode="indeterminate" style="margin:0"></mat-progress-spinner>
      } @else {
      <ng-container>{{ this.Price?.DiscountedTotalPrice | currency }}</ng-container>
      }
    </title-with-divider>
    }

    <div class="title-with-divider"></div>

    <button mat-raised-button>{{ 'tIntellitrailer.Booking.Components.BookingOption.Select' | translate : 'Select'}}</button>
  </app-card>
  }

  @if (type) {
  <list-item mobile-content>
    <img src="{{ type.PictureUri }}" />
    <div>
      <h2>{{ type.Alias }}</h2>

      @if (showPrice) {
      <small>
        @if (loadingPrice) {
        <mat-progress-spinner diameter="25" mode="indeterminate"></mat-progress-spinner>
        } @else {
        <ng-container>{{'tIntellitrailer.Booking.Components.BookingOption.lblPrice' | translate: 'Price'}}: {{ this.Price?.DiscountedTotalPrice | currency }}</ng-container>
        }
      </small>
      <br />
      }

      @if (booking && booking.Price && showPrice) {
      <small>{{ booking.Price?.DiscountedTotalPrice | currency }}</small>
      }
      <small *ngFor="let item of dimensions">
        @if(item.Value) { {{ item.Shorthand | translate }}: {{ item.Value }}{{ item.Unit | translate}} }
      </small><br />
      <small *ngFor="let item of weights">
        @if(item.Value) { {{ item.Shorthand | translate }}: {{ item.Value }}{{ item.Unit | translate}} }
      </small>
    </div>
  </list-item>
  }
</data-list>
